var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"btn",style:([{ background: _vm.configObj.bgcolor }]),on:{"click":_vm.ljzx}},[_vm._v(" "+_vm._s(_vm.configObj.text || "立即咨询")+" "),_c('img',{attrs:{"src":_vm.configObj.img || require('@/assets/icon/按钮蓝色箭头.svg')}})])}
var staticRenderFns = []

export { render, staticRenderFns }